import modal from './modal.js'
export default { modal }
